import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import { Field, getFormValues } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import styles from './styles';
import {
  selectSkillsetBuildOptions,
  selectSkillsetLookOptions,
} from '../../../../store/selectors';
import { FORMS } from '../../../../constants';
import TextField from '../../../../fields/reduxForm/GeneralTextField';
import { getSkillsetOfType } from '../../../../store/actions/skillset';
import { positiveNumber } from '../../../../utilities/validators';
import SelectFormField from '../../../../fields/reduxForm/SelectFormField';

const propTypes = {
  classes: PropTypes.shape({
    cardHeaderRoot: PropTypes.string,
    cardHeaderTitle: PropTypes.string,
    formGroup: PropTypes.string,
    halfFormGroup: PropTypes.string,
    formRow: PropTypes.string,
  }).isRequired,
  onGetSkillsetOfType: PropTypes.func.isRequired,
  skillsetBuildOptions: PropTypes.array.isRequired,
  skillsetLookOptions: PropTypes.array.isRequired,
};
const getNumberOfNewBuildsOptions = () => {
  const options = ['0', '1-3', '4-10', '11-20', '20+'].map(data => (
    <option value={data}>{data}</option>
  ));
  return options;
};
export const FieldsGroupFour = props => {
  const {
    classes,
    onGetSkillsetOfType,
    skillsetBuildOptions,
    skillsetLookOptions,
  } = props;

  useEffect(() => {
    if (!skillsetBuildOptions.length) onGetSkillsetOfType('build');
    if (!skillsetLookOptions.length) onGetSkillsetOfType('look');
  }, []);

  return (
    <Card>
      <CardHeader
        classes={{
          root: classes.cardHeaderRoot,
          title: classes.cardHeaderTitle,
        }}
        title="Step 4: Additional Info"
      />
      <CardContent>
        <div className={classes.formRow}>
          <div
            className={classNames(classes.formGroup, classes.halfFormGroup)}
            style={{ display: 'flex', alignItems: 'flex-end' }}
          >
            <Field
              name="custom:newBuildsPerYear"
              label="New builds per year."
              component={SelectFormField}
              props={{
                id: 'new-builds-text-field',
                label: 'Number of New Builds completed over the past year?',
                fullWidth: true,
              }}
            >
              <option />
              {getNumberOfNewBuildsOptions()}
            </Field>
          </div>
          <div
            className={classNames(classes.formGroup, classes.halfFormGroup)}
            style={{ display: 'flex', alignItems: 'flex-end' }}
          >
            <Field
              name="custom:renovationsPerYear"
              label="Number of Renovations completed over the past year?"
              component={SelectFormField}
              props={{
                id: 'renovationsPerYear-text-field',
                label: 'Number of Renovations completed over the past year?',
                fullWidth: true,
              }}
            >
              <option />
              {getNumberOfNewBuildsOptions()}
            </Field>
          </div>
        </div>
        <div className={classes.formRow}>
          <div
            className={classNames(classes.formGroup, classes.halfFormGroup)}
            style={{ display: 'flex', alignItems: 'flex-end' }}
          >
            <Field
              name="custom:employeesCount"
              label="Number of permanent employees in your business?"
              component={TextField}
              props={{
                id: 'permanent-employees-text-field',
                label: 'Number of permanent employees in your business?',
                fullWidth: true,
                type: 'number',
              }}
              validate={[positiveNumber]}
            />
          </div>
          <div
            className={classNames(classes.formGroup, classes.halfFormGroup)}
            style={{ display: 'flex', alignItems: 'flex-end' }}
          >
            <Field
              name="custom:businessYears"
              label="Years in business."
              component={TextField}
              props={{
                id: 'business-years-text-field',
                label: 'Number of years your business has been open?',
                fullWidth: true,
                type: 'number',
              }}
              validate={[positiveNumber]}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

FieldsGroupFour.propTypes = propTypes;

const mapStateToProps = state => ({
  formValues: getFormValues(FORMS.REGISTRATION_LONG)(state),
  skillsetBuildOptions: selectSkillsetBuildOptions()(state),
  skillsetLookOptions: selectSkillsetLookOptions()(state),
});

const mapDispatchToProps = dispatch => ({
  onGetSkillsetOfType: type => dispatch(getSkillsetOfType(type)),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FieldsGroupFour),
);
